import React from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { Typography } from "antd";
import { isEmpty, map, get, find } from "lodash";
import { useSmartAssistStore } from "../store";
const { Title } = Typography;


const QuestionsForm = () => {
  const { responses, setResponses, isSubmitDisabled, setIsSubmitDisabled, saQuestionsList, saSubmitBulkResponse, saQuestionListMap, saEvaluateResolution, saPastResponseData, saEvaluatedResolution } = useSmartAssistStore();

  const handleChange = (fieldKey, value) => {
    const updatedResponses = {
      ...responses,
      [fieldKey]: value,
    };
    setResponses(updatedResponses);
    if (Object.keys(updatedResponses).length >= Object.keys(saQuestionListMap || {}).length) {
      setIsSubmitDisabled(false);
    }
  };

  const onSubmitQuestions = async (e) => {
    e.preventDefault()
    const result = {
      question_responses: Object.entries(responses || {}).map(([id, response]) => {
        const question = saQuestionListMap[id];
        if (!question) {
          toast.error("Please fill all questions and then submit");
          return;
        };
        return {
          question_id: question.id,
          question_text: question.question_text,
          response_type: question.response_type,
          response: Array.isArray(response) ? response : [response],
          issue_type: question.type,
          issue_sub_type: question.issue_key,
          field_key: question.field_key
        };
      })
    };
    await saSubmitBulkResponse(saQuestionsList.formId, result);
    saEvaluateResolution(saQuestionsList.formId);
  };

  const renderQuestion = (question) => {
    const { id, question_text, response_type, response_options, field_key } = question;

    function getResponseByQuestionId(questionId) {
      const pastResponse = saPastResponseData?.find(item => item.question_id === questionId);

      // Transform the response if it exists
      if (pastResponse?.response) {
        // Calculate days ago from the submitted timestamp
        const submittedDate = new Date(pastResponse.submitted);
        const currentDate = new Date();

        const daysAgo = Math.floor((currentDate - submittedDate) / (1000 * 60 * 60 * 24));

        const transformedResponse = map(get(pastResponse, 'response', []), (value) => {
          const matchedOption = find(response_options, { value });
          const label = get(matchedOption, 'label', value);
          return `marked: ${label} ${daysAgo} days ago`;
        });
        return transformedResponse;
      }
    }

    return (
      <div
        key={field_key}
        className="card mx-2"
        style={{
          flex: "0 0 300px",
          maxWidth: "250px",
        }}
      >
        <div className="badge bg-warning-subtle fs-1 mb-1 text-dark text-start" >
          <span style={{ fontSize: "9px", whiteSpace: "normal", wordWrap: "break-word" }}>
            {getResponseByQuestionId(id)?.map((resp, index) => <span key={index}>{resp}</span>)}
          </span>
        </div>
        <div className="card-header bg-primary">
          <Title className="fs-1 mb-0 text-white">{question_text}</Title>
        </div>
        <div className="card-body">
          {response_type === "SINGLE" && (
            <div>
              {response_options?.map((option) => (
                <div className="form-check" key={option.value}>
                  <input
                    id={id + option.value}
                    type="radio"
                    className="form-check-input"
                    name={field_key}
                    value={option.value}
                    checked={responses[id] === option.value}
                    onChange={() => handleChange(id, option.value)}
                  />
                  <label htmlFor={id + option.value} className="form-check-label">{option.label}</label>
                </div>
              ))}
            </div>
          )}
          {response_type === "MULTI" && (
            <div>
              {response_options?.map((option) => (
                <div className="form-check" key={option.value}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value={option.value}
                    checked={responses[id]?.includes(option.value) || false}
                    onChange={(e) => {
                      const valueArray = responses[id] || [];
                      handleChange(
                        id,
                        e.target.checked
                          ? [...valueArray, option.value]
                          : valueArray.filter((val) => val !== option.value)
                      );
                    }}
                  />
                  <label className="form-check-label">{option.label}</label>
                </div>
              ))}
            </div>
          )}
          {response_type === "FREEFORM" && (
            <div>
              <textarea
                className="form-control"
                rows="3"
                value={responses[id] || ""}
                onChange={(e) => handleChange(id, e.target.value)}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <form style={{ fontFamily: "Arial, sans-serif" }}>
      <div
        className="d-flex   pt-1 px-5 pb-5 overflow-x-auto"
        style={{
          maxHeight: "80vh",
        }}
      >
        {get(saQuestionsList, 'probing.issues', []).map((question) => renderQuestion(question))}
        {get(saQuestionsList, 'probing.products', []).map((question) => renderQuestion(question))}
      </div>
      {isEmpty(saEvaluatedResolution.products) && isEmpty(saEvaluatedResolution.issues) && <div className="mt-4 text-center">
        <Button
          type="submit"
          disabled={isSubmitDisabled}
          onClick={onSubmitQuestions}
        >
          Get Resolution
        </Button>
      </div>}
    </form>
  );
};

export default QuestionsForm;
